<div class="modal">
  <div class="close-link">
    <span class="close" [mat-dialog-close]></span>
  </div>
  <h1 class="modal__title">{{ 'pages.apps.modal.title' | translate }}</h1>
  <form class="modal__form" [formGroup]="form" (ngSubmit)="onSubmit()">

    <div class="files" formArrayName="fileControls">
      <div class="file" *ngFor="let control of fileControls.controls; let i = index" [formGroupName]="i">
        <app-form-file-upload
          *ngIf="!control.get('url')?.value"
          appDragAndDropFiles
          formControlName="file"
          accept="image/*"
        >
        {{ 'formFilUpload.dragAndDrop' | translate }}
        </app-form-file-upload>

        <div class="file-preview" *ngIf="control.get('url')?.value">
          <img [src]="control.get('url')?.value">
          <div class="file-name" *ngIf="control.get('name')?.value">
            {{ control.get('name')?.value }}
          </div>
        </div>

        <button
          class="btn btn__icon delete_file"
          type="button"
          (click)="removeFileControl(i)">
          <svg width="24px" height="24px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
            <path d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm0 0" fill="#f44336"/>
            <path d="m350.273438 320.105469c8.339843 8.34375 8.339843 21.824219 0 30.167969-4.160157 4.160156-9.621094 6.25-15.085938 6.25-5.460938 0-10.921875-2.089844-15.082031-6.25l-64.105469-64.109376-64.105469 64.109376c-4.160156 4.160156-9.621093 6.25-15.082031 6.25-5.464844 0-10.925781-2.089844-15.085938-6.25-8.339843-8.34375-8.339843-21.824219 0-30.167969l64.109376-64.105469-64.109376-64.105469c-8.339843-8.34375-8.339843-21.824219 0-30.167969 8.34375-8.339843 21.824219-8.339843 30.167969 0l64.105469 64.109376 64.105469-64.109376c8.34375-8.339843 21.824219-8.339843 30.167969 0 8.339843 8.34375 8.339843 21.824219 0 30.167969l-64.109376 64.105469zm0 0" fill="#fafafa"/>
          </svg>
        </button>
      </div>

      <div class="file empty-state" *ngIf="fileControls.length === 0">
        <p class="empty-text">{{ 'pages.apps.modal.noFiles' | translate }}</p>
      </div>
    </div>

    <button
      type="button"
      class="btn add_more_file"
      (click)="addNewFileControl()"
      [disabled]="isAddAllowed"
    >
      {{ 'pages.apps.modal.addMore' | translate }}
    </button>

    <div class="modal__submit-btn">
      <button class="btn btn__primary" type="submit" [disabled]="form.invalid || form.pristine || isLoading">
        <ng-container *ngIf="isLoading; else add">
          <mat-spinner diameter="22" color="secondary"></mat-spinner>
        </ng-container>
        <ng-template #add>{{ 'pages.apps.modal.confirm' | translate }}</ng-template>
      </button>
    </div>
  </form>
</div>
